import { createFileRoute } from '@tanstack/react-router';
import { GoalPickerScreen } from '../components/GoalPickerScreen.tsx';

/**
 * In-app goal picker. Same flow as marketing onboarding but rendered inside the
 * AppShell (keeps the sidebar) for signed-in users — reached from the dashboard
 * empty-state CTA when no goal is set yet. Persists to the profile on Continue.
 */
export const Route = createFileRoute('/_app/goal')({
  component: GoalPage,
});

function GoalPage() {
  return <GoalPickerScreen eyebrow="Your goal" />;
}
